import { render, staticRenderFns } from "./CharLimit.vue?vue&type=template&id=056f9390"
import script from "./CharLimit.vue?vue&type=script&lang=js"
export * from "./CharLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports